// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  header: {
    marginTop: theme.spacing(4),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  signedOutNotice: {
    marginTop: theme.spacing(2),
  },
  errorMessage: {
    minHeight: '3em',
    marginTop: theme.spacing(1),
    color: theme.palette.error.main,
  },
  buttonWrapper: {
    marginTop: theme.spacing(4),
    position: 'relative',
    display: 'inline-block',
  },
  button: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  buttonOkta: {
    marginTop: theme.spacing(10),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    border: '1px solid #ffffff',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  forgotText: {
    color: theme.palette.primary.main,
  },
  captcha: {
    marginTop: theme.spacing(2),
  },
  emailDisplay: {
    fontWeight: 500,
    color: 'white',
  },
  emailSection: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
  },
  backButton: {
    mr: 1,
  },
  emailWrapper: {
    flex: 1,
  },
});

export default styles;
